var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 5.33334H12.6667M3.33333 5.33334C2.97971 5.33334 2.64057 5.19286 2.39052 4.94281C2.14048 4.69277 2 4.35363 2 4.00001C2 3.64638 2.14048 3.30724 2.39052 3.0572C2.64057 2.80715 2.97971 2.66667 3.33333 2.66667H12.6667C13.0203 2.66667 13.3594 2.80715 13.6095 3.0572C13.8595 3.30724 14 3.64638 14 4.00001C14 4.35363 13.8595 4.69277 13.6095 4.94281C13.3594 5.19286 13.0203 5.33334 12.6667 5.33334M3.33333 5.33334V12C3.33333 12.3536 3.47381 12.6928 3.72386 12.9428C3.97391 13.1929 4.31304 13.3333 4.66667 13.3333H11.3333C11.687 13.3333 12.0261 13.1929 12.2761 12.9428C12.5262 12.6928 12.6667 12.3536 12.6667 12V5.33334M6.66667 8.00001H9.33333",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveOutline);
export default __webpack_public_path__ + "static/media/ArchiveOutline.6efafdd2398621751c07e17361bd5f3c.svg";
export { ForwardRef as ReactComponent };